import { DndHeader } from "../DragInDrop.type"

interface TableHeaderProps {
  columns: DndHeader[]
}


export function DragInDropHeader({ columns }: TableHeaderProps) {
  const newColumns = columns.filter((col) => col.visible !== false)

  return (
    <thead>
      <tr>
        <th
          key={'sort'}
          className={`
                text-muted fw-bolder text-uppercase fs-7
                ${newColumns[0].sortable ? 'cursor-pointer user-select-none' : ''}
                ${newColumns[0].align === 'center' ? 'text-center' : ''}
                ${newColumns[0].align === 'right' ? 'text-end' : ''}
              `}
          style={{ width: '40px', touchAction: 'none' }}


        >
          <div className='d-flex align-items-center'>

            <span><i className="bi bi-hand-index fs-1"></i></span>
          </div>
        </th>

        {newColumns
          .map((column) => (
            <th
              key={column.key}
              className={`
                text-muted fw-bolder text-uppercase fs-7
                ${column.sortable ? 'cursor-pointer user-select-none' : ''}
                ${column.align === 'center' ? 'text-center' : ''}
                ${column.align === 'right' ? 'text-end' : ''}
              `}
              style={{ width: column.width }}

            >
              <div className='d-flex align-items-center'>

                <span>{column.key}</span>
              </div>
            </th>
          ))}
      </tr>
    </thead>
  )
}